<script>
    import { createEventDispatcher } from "svelte";
    import { navigate } from "../../router";
    import { Button, Label } from "../widget";
    import { categories } from "../../articles";

    export let wedding_guid;
    export let isEdit;
    export let hasEdit;
    export let category;

    const dispatch = createEventDispatcher();
    const on = (c) => {
        dispatch("action");
        navigate(hasEdit ? `#/wedding/${wedding_guid}/${c.id}?edit=${isEdit}` : `#/wedding/${wedding_guid}/${c.id}`);
    };
</script>

{#each categories as c (c.id)}
    <Button action={() => on(c)}>
        <Label
            noshrink
            text={c.label}
            h="48px"
            borderRight
            color={category == c.id ? "var(--primary-light-color)" : "inherit"} />
    </Button>
{/each}
